"use strict";
var IntervalObservable_1 = require('./IntervalObservable');
exports.interval = IntervalObservable_1.IntervalObservable.create;
//# sourceMappingURL=interval.js.map


//////////////////
// WEBPACK FOOTER
// /home/vsts/work/1/s/digicerba-modules/digicerba-catalogue-examen/digicerba-catalogue-examen-web/src/angular/cerba/~/rxjs/observable/interval.js
// module id = ../../../../rxjs/observable/interval.js
// module chunks = 3